import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTeacherCreatedTests, DeleteTestDataTemp } from '../../actions/testActions';
import { Link } from 'react-router-dom';
import { FaEye, FaTrash, FaSearch, FaPlus, FaChartBar, FaEdit } from 'react-icons/fa';
import './MyCreatedTest.css';
import { Spinner } from 'react-bootstrap';

function MyCreatedTest() {
  const dispatch = useDispatch();
  const teacherTestData = useSelector(state => state.tests.teacherCreatedTest);
  const loading = useSelector(state => state.tests.teacherCreatedTestloading);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [testToDelete, setTestToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showResultsModal, setShowResultsModal] = useState(false);
  const [currentTestResults, setCurrentTestResults] = useState([]);
  const [currentTestName, setCurrentTestName] = useState('');

  useEffect(() => {
    if (teacherTestData?.length === 0) {
      dispatch(fetchTeacherCreatedTests());
    }
  }, []);
  const handleViewResults = (test) => {
    setCurrentTestResults(test.submitedBy || []);
    setCurrentTestName(test.testName);
    setShowResultsModal(true);
  };

  // Handle loading state
  if (loading && teacherTestData.length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '30vh', color: '#0096c7' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  const handleDeleteClick = (testId, testName) => {
    setTestToDelete({ id: testId, name: testName });
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (testToDelete) {
      dispatch(DeleteTestDataTemp({ testId: testToDelete.id }));
      dispatch(fetchTeacherCreatedTests());
    }
    setShowDeleteModal(false);
  };

  const filteredTests = teacherTestData?.filter(test =>
    test.testName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    test.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="test-list-container">
      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="modal" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 1050,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <div className="bg-white p-4 rounded shadow" style={{ width: '400px' }}>
            <h5 className="text-primary">Confirm Delete</h5>
            <p>Are you sure you want to delete <strong>"{testToDelete?.name}"</strong>?</p>
            <div className="d-flex justify-content-end gap-3 mt-4">
              <button 
                className="btn btn-outline-secondary" 
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button 
                className="btn btn-danger" 
                onClick={confirmDelete}
              >
                <FaTrash className="me-1" /> Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Results Modal */}
      {showResultsModal && (
        <div className="modal" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 1050,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          
        }}>
          <div className="bg-white p-4 rounded shadow" style={{ width: '90%', maxWidth: '800px', maxHeight: '80vh', overflowY: 'auto' }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="text-primary">Student Results for: {currentTestName}</h5>
              <button 
                className="btn btn-close" 
                onClick={() => setShowResultsModal(false)}
              />
            </div>
            
            {currentTestResults.length === 0 ? (
              <div className="text-center py-4">
                <p>No students have taken this test yet.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead className="table-light">
                    <tr>
                      <th>Student Name</th>
                      <th>Correct Answers</th>
                      <th>Total Marks</th>
                      <th>Obtained Marks</th>
                      <th>Percentage</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentTestResults.map((result, index) => (
                      <tr key={index}>
                        <td>{result.name}</td>
                        <td>{result.correctAnswers}/{result.totalQuestions}</td>
                        <td>{result.totalMarks}</td>
                        <td>{result.obtainedMarks}</td>
                        <td>{result.percentageObtained}%</td>
                        <td>
                          <span className={`badge ${result.passStatus === 'Pass' ? 'bg-success' : 'bg-danger'}`}>
                            {result.passStatus}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="test-list-card">
        <div className="test-list-header">
          <div className="test-list-header-content">
            <h3 className="test-list-title">My Tests</h3>
            <div className="test-list-controls">
              <div className="test-list-search">
                <span className="test-list-search-icon">
                  <FaSearch />
                </span>
                <input
                  type="text"
                  className="test-list-search-input"
                  placeholder="Search tests..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <Link to="/create-test" className="test-list-create-btn">
                <FaPlus className="test-list-create-icon" /> Create Test
              </Link>
            </div>
          </div>
        </div>

        <div className="test-list-body">
          {filteredTests?.length === 0 ? (
            <div className="text-center py-5">
              <div className="mb-3" style={{ fontSize: '3rem', color: '#6c757d' }}>
                <FaSearch />
              </div>
              <h5 className="text-secondary">No tests found</h5>
              <p className="text-muted">Create your first test to get started</p>
              <Link to="/create-test" className="test-list-create-btn" style={{margin:'0 auto' , maxWidth:"50%"}}>
                <FaPlus className="test-list-create-icon" /> Create Test
              </Link>
            </div>
          ) : (
            <div className="test-list-grid">
              {filteredTests?.map((test, index) => (
                <div className="test-list-item" key={index}>
                  <div className="test-list-item-card">
                    <div className="test-list-item-body">
                      <div className="test-list-item-header">
                        <h5 className="test-list-item-title">{test.testName}</h5>
                        <button 
                          className="test-list-item-delete"
                          onClick={() => handleDeleteClick(test._id, test.testName)}
                          title="Delete test"
                        >
                          <FaTrash />
                        </button>
                      </div>
                      
                      <div className="mb-3">
                        <div className="d-flex align-items-center mb-2">
                          <span className="badge bg-info me-2">{test.category}</span>
                          <small className="text-muted">{test.questions.length} questions</small>
                        </div>
                        <div className="d-flex gap-4">
                          <div>
                            <small className="text-muted">Duration</small>
                            <p className="mb-0 fw-bold">{test.totalMinutes} mins</p>
                          </div>
                          <div>
                            <small className="text-muted">Total Marks</small>
                            <p className="mb-0 fw-bold">{test.totalMarks}</p>
                          </div>
                          <div>
                            <small className="text-muted">Attempts</small>
                            <p className="mb-0 fw-bold">{test.submitedBy?.length || 0}</p>
                          </div>
                        </div>
                      </div>

                      <div className="test-list-item-actions">
                        <Link 
                          to={`/view-test/${test._id}`} 
                          className="test-list-item-view"
                        >
                          <FaEye className="me-1" /> View
                        </Link>
                        <Link
                          to={`/edit-test/${test._id}`}
                          className="test-list-item-edit"
                        >
                          <FaEdit className="me-1" /> Edit
                        </Link>
                        <button
                          className="test-list-item-results"
                          onClick={() => handleViewResults(test)}
                          // disabled={!test.submitedBy || test.submitedBy.length === 0}
                        >
                          <FaChartBar className="me-1" /> Results
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MyCreatedTest;